(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["zuitable-careers"] && !Shopify.designMode) return;
  try {
    
// No external JS needed. If you want smooth auto-play after theme lazy loading, you could hook it here.
(function(){
  const root = document.getElementById('zuitable-careers-{{ section.id }}');
  if(!root) return;
  root.querySelectorAll('video').forEach(v=>{ try{ v.play().catch(()=>{});}catch(e){} });
})();

  } catch(e) { console.error(e); }
})();
})();
